import * as React from "react";
import { cls } from "@utdanningsdirektoratet/utils/cls";
import styles from "./Radio.module.less";

interface RadioProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "value"> {
  label?: React.ReactNode | string;
  className?: string;
  error?: boolean;
  boxed?: boolean;
  checked?: boolean;
  disabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  children?: React.ReactNode;
  value?: React.InputHTMLAttributes<HTMLInputElement>["value"] | boolean;
}

const Radio = React.forwardRef<HTMLInputElement, RadioProps>(
  ({ label, className, error = false, boxed, children, checked, disabled, onChange, value, ...rest }, forwardedRef) => {
    const ref = React.useRef<HTMLInputElement>(null);

    React.useImperativeHandle(forwardedRef, () => ref.current!, [ref]);

    const radioClass = cls(
      {
        [styles.radioChecked]: checked,
      },
      className
    );
    const inputClass = cls({
      [styles.radioInput]: true,
      [styles.radioInputError]: error,
    });
    const labelClass = cls({
      [styles.radioInputLabel]: true,
      [styles.radioInputLabelEmpty]: !label,
    });
    const boxClass = cls({
      [styles.radioBoxed]: boxed || !!children,
      [styles.radioWithChildren]: !!children,
    });

    return (
      <div className={radioClass}>
        <div className={boxClass}>
          <label // eslint-disable-line jsx-a11y/label-has-associated-control
            className={styles.radioWrapper}
          >
            <input
              {...rest}
              ref={ref}
              disabled={disabled}
              checked={checked}
              onChange={onChange}
              type="radio"
              aria-disabled={disabled}
              aria-checked={checked}
              className={inputClass}
              value={`${value}`}
            />
            <span className={labelClass}>{label}</span>
          </label>
        </div>
        {!!children && checked ? <div className={styles.radioExpanded}>{children}</div> : null}
      </div>
    );
  }
);

export default Radio;
